import React, { useEffect, useState } from "react";
import { viewJobDescription } from "../../../../Auth/Services/metadataService";
import { Download, X } from "lucide-react";
import { handleOutsideClick } from "../../../../Helpers/HandleOutsideClick";

const JobDescriptionModal = ({ show, onHide, fullPath }) => {
	const [isVisible, setIsVisible] = useState(false);
	const [shouldRender, setShouldRender] = useState(show);

	useEffect(() => {
		if (show) {
			setShouldRender(true);

			setTimeout(() => {
				setIsVisible(true);
			}, 10);
		} else {
			setIsVisible(false);

			setTimeout(() => {
				setShouldRender(false);
			}, 500);
		}
	}, [show]);

	// Extract filename
	const fileName = fullPath?.includes("/")
		? fullPath.split("/").pop()
		: fullPath;

	const jdUrl = fileName ? viewJobDescription(fileName) : null;

	if (!shouldRender) return null;

	return (
		<div
			className={`fixed inset-0 z-50 flex justify-end transition-opacity duration-500 ${isVisible ? "bg-black/40 opacity-100" : "bg-black/0 opacity-0"}`}
			onClick={(e) => handleOutsideClick(e, onHide)}
		>
			{/* Drawer */}
			<div
				onClick={(e) => e.stopPropagation()}
				className={`bg-white h-full w-[65%] shadow-[ -10px_0px_30px_rgba(0,0,0,0.15) ] flex flex-col transform transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "translate-x-0" : "translate-x-full"}`}
			>
				{/* Header */}
				<div className="flex items-center justify-between px-6 py-4 border-b">
					<h2 className="text-lg font-semibold text-gray-800">
						Job Description Document
					</h2>

					<button
						onClick={onHide}
						className="p-2 rounded-md hover:bg-gray-100 transition"
					>
						<X size={18} />
					</button>
				</div>

				{/* Body */}
				<div className="flex-1 overflow-hidden">
					{jdUrl ? (
						<iframe
							src={jdUrl}
							title="Job Description"
							className="w-full h-full border-none"
						/>
					) : (
						<div className="flex items-center justify-center h-full text-gray-500">
							Job Description file not available.
						</div>
					)}
				</div>

				{/* Footer */}
				<div className="flex justify-end gap-3 px-6 py-4 border-t">
					<button
						onClick={onHide}
						className="px-4 py-2 text-sm border rounded-md hover:bg-gray-100"
					>
						Close
					</button>

					{jdUrl && (
						<a
							href={jdUrl}
							download
							target="_blank"
							rel="noreferrer"
							className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
						>
							<Download size={16} />
							Download JD
						</a>
					)}
				</div>
			</div>
		</div>
	);
};

export default JobDescriptionModal;
